export enum VitalSignAttributes {
  QT_PA_SISTOLICA = 1,
  QT_PA_DIASTOLICA = 2,
  QT_FREQ_RESP = 3,
  QT_TEMP = 4,
  QT_SATURACAO_O2 = 6,
  QT_GLICEMIA_CAPILAR = 7,
  QT_PAM = 8,
  QT_FREQ_CARDIACA = 9,
  QT_ESCALA_DOR = 10,
  QT_BCF = 11,
  QT_PESO = 12,
  QT_ALTURA_CM = 13,
  QT_IMC = 14,
  QT_SUPERF_CORPORIA = 15,
  QT_PVC_H2O = 16,
  QT_PVC = 17,
  QT_PAE = 18,
  QT_PRESSAO_INTRA_CRANIO = 19,
  QT_PRESSAO_INTRA_ABD_H2O = 20,
  QT_TEMP_INCUBADORA = 21,
  QT_PERIMETRO_CEFALICO = 22,
  QT_ANGULO_CABECEIRA = 120,
  QT_BCF_2 = 141,
  QT_BCF_3 = 146,
}